import React, {useEffect} from "react";

import {Form, Table} from 'react-bootstrap';
import {Dropdown} from '../../../../../shared/ui/Dropdown';

const RpiGPIOTable = (props) => {

  return (
    <Table>
      <tbody>
      <tr>
        <th className="text-start"><span>Name</span></th>
        <td className="text-end"><span>{props.device.name}</span></td>
      </tr>
      <tr>
        <th className="text-start"><span>Direction</span></th>
        <td className="text-end"><span>{props.device.direction}</span></td>
      </tr>
      <tr>
        <th className="text-start"><span>GPIO</span></th>
        <td className="text-end"><span>{props.device.gpio}</span></td>
      </tr>
      </tbody>
    </Table>
  )
}

const RpiGPIOForm = (props) => {

  // verify all fields are filled before saving
  useEffect(() => {
    if (props.device.name && props.device.direction && props.device.gpio) {
      props.setSaveDisabled(false);
    } else {
      props.setSaveDisabled(true);
    }
  }, [props.device]);

  return (
    <Form>
      <Form.Group>
        <Form.Label>Name</Form.Label>
        <Form.Control
          type="text"
          name="name"
          value={props.device.name}
          onChange={props.handleChange}/>
      </Form.Group>
      <Form.Group>
        <Form.Label>GPIO</Form.Label>
        <Dropdown
          name="direction"
          options={[
            {value: 'in', label: 'in'},
          ]}
          value={props.device.direction}
          onChange={props.handleChange}
          placeholder="select..."
          block
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>GPIO</Form.Label>
        <Dropdown
          name="gpio"
          options={[
            {value: '23', label: '23'},
          ]}
          value={props.device.gpio}
          onChange={props.handleChange}
          placeholder="select..."
          block
        />
      </Form.Group>
    </Form>
  )
}

export {RpiGPIOForm, RpiGPIOTable};